import type { Handler } from './handler';
import type { ApiFetchFaqPort, FaqCategory } from './ports/api-fetch-faq.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const fetchFaqHandler: Handler<Params, Ports, Result> = async (
  ports = {
    apiFetchFaq: resolveAdapter('apiFetchFaq'),
  },
) => {
  const [categories, error] = await tryCatch(ports?.apiFetchFaq.handle());

  if (error) {
    console.error('Error fetching FAQ:', error);
  }

  return categories || [];
};

type Params = undefined;

type Ports = {
  apiFetchFaq: ApiFetchFaqPort;
};

type Result = Promise<FaqCategory[]>;
